import React, { ChangeEvent, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { Box, FormHelperText, FormLabel, Grid } from '@material-ui/core'

import { IOSSwitch } from './IOSSwitch'
import { BootstrapInput } from './BootstrapInput'

import { useSettingsPageStyles } from '../hooks/settingsPageStylesHook'

import { StoreAccountModel } from '../types/accountProps'

export interface MinimumProductStocksFormProps {
  account: StoreAccountModel

  onChange: (minimumProductStocks: number | undefined) => void
}

export const MinimumProductStocksForm =
  observer(
    ({account, onChange}: MinimumProductStocksFormProps) => {
      const classes = useSettingsPageStyles()

      const [minimumProductStocks, setMinimumProductStocks] = useState(account.minimumProductStocks)

      const isMinimumEnabled = minimumProductStocks != null

      useEffect(
        () => setMinimumProductStocks(account.minimumProductStocks),
        [account.minimumProductStocks])

      useEffect(() => {
        onChange(minimumProductStocks)
      }, [minimumProductStocks, onChange])

      const onChangeIsMinimumEnabled =
        () => setMinimumProductStocks(isMinimumEnabled ? undefined : (account.minimumProductStocks ?? 0))

      const onInternalChange =
        (e: ChangeEvent<HTMLTextAreaElement>) =>
          setMinimumProductStocks(parseInt(e.target.value))

      return (
        <Grid item xs={6}>
          <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
            <Grid item xs={12} className={classes.root}>

              <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <FormLabel className={classes.unifiedPricesLabel}>
                    Минимальный остаток
                  </FormLabel>

                  <FormHelperText className={classes.helperText}>
                    Укажите число, при котором остаток на маркетплейсе будет считаться отсутствующим
                  </FormHelperText>
                </Box>

                <IOSSwitch checked={isMinimumEnabled} onChange={onChangeIsMinimumEnabled}/>
              </Box>

              {
                isMinimumEnabled &&
                <Box display="flex">
                  <BootstrapInput
                    fullWidth
                    placeholder="0"
                    value={minimumProductStocks}
                    onChange={onInternalChange}/>
                </Box>
              }
            </Grid>
          </Grid>
        </Grid>
      )
    })